var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.993 18.0006C35.993 27.0918 29.2561 34.6076 20.5043 35.8272C19.686 35.9407 18.8488 36 17.9989 36C17.018 36 16.0547 35.9218 15.1166 35.7705C6.54887 34.3906 0.00488281 26.9593 0.00488281 18.0006C0.00488281 8.05942 8.06193 0 18.0002 0C27.9385 0 35.9955 8.05942 35.9955 18.0006H35.993Z",
    fill: "#1C1C1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30365 7.93854L15.6028 19.0376L7.25195 28.0619H9.13193L16.4438 20.1614L22.351 28.0619H28.7475L19.9818 16.3385L27.7552 7.93854H25.8752L19.1421 15.2147L13.7014 7.93854H7.3049H7.30365ZM10.0675 9.3234H13.0054L25.9811 26.677H23.0433L10.0675 9.3234Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.8c9f9ab6b1f3282cbb5b3a0a481fd781.svg";
export { ForwardRef as ReactComponent };